export default __webpack_public_path__ + "static/media/facebook_black_icon.f03b6e5a.svg";